export default __webpack_public_path__ + "static/media/item_5.413b9adc.webp";